/**
 * Mobile Detection Utility
 * Detects if user is on a mobile/tablet device
 */

export const isMobileDevice = () => {
  // Check user agent
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  
  // Check for mobile keywords in user agent
  const mobileRegex = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile|tablet/i;
  
  // Check screen size (mobile typically < 768px width)
  const isMobileScreen = window.innerWidth < 768;
  
  // Check touch capability
  const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  
  return mobileRegex.test(userAgent) || (isMobileScreen && isTouchDevice);
};

export const getDeviceType = () => {
  if (/iPad|Android(?!.*mobile)/i.test(navigator.userAgent)) {
    return 'tablet';
  }
  if (/iPhone|Android.*mobile|webOS|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    return 'phone';
  }
  return 'desktop';
};

export const isTouchDevice = () => {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
};
